




















// import { ProfileModule } from '@app/componentlib/src/store/modules/profile'
import Vue from 'vue'
import Component from 'vue-class-component'
// import { PsyModule } from '../../store/modules/psydata'

@Component<GdprExport>({
  props: {
    title: String,
    description: String,
    downloadDescription: String,
    pSYJournalInfo: String,
    loadingText: String,
    downloadButtonText: String,
    isProxy: Boolean,
    proxyWarning: String,
    gdprDataProvider: Function,
    customClass: String,
    hasPsychologistJournals: Function
  }
})

export default class GdprExport extends Vue {
  /**
   * Props variables
   */
  title: string | undefined
  description: string | undefined
  downloadDescription: string | undefined
  pSYJournalInfo: string | undefined
  loadingText: string | undefined
  downloadButtonText: string | undefined
  isProxy: boolean | undefined
  proxyWarning: string | undefined
  // test: function | undefined
  gdprDataProvider: Function | undefined
  class: string | undefined
  hasPsychologistJournals: Function | undefined
  /**
   * Component state variables
   */
  gotPsychologistJournals: boolean = false
  isDownloading: boolean = false
  downloadError: boolean = false

  /**
   * Lifecycle
   */
  async mounted () {
    if (this.pSYJournalInfo !== undefined && this.hasPsychologistJournals !== undefined) {
      this.gotPsychologistJournals = await this.hasPsychologistJournals()
    }
  }

  /**
   * Getters
   */

  /**
   * Methods
   */
  async getGdprData () {
    // Start getting data, reset error message if any and set spinner running with isDownloading = true
    if(this.gdprDataProvider !== undefined) {
          this.downloadError = false
    this.isDownloading = true
      // Get the gdpr data we need to give it to the user from the gdpr data provider
      let data = await this.gdprDataProvider()
      console.log('data from gdprDataProvider: ', data)
      // await ProfileModule.setGdprData(data)
      this.showMyData(data)
    }
  }

  showMyData (data: any) {
    this.isDownloading = false
    // if (ProfileModule.gdprData !== null) {
    if (data !== null) {
      this.download('mydata.html', data)
    } else {
      this.downloadError = true
    }
  }

  download (filename: string, text: string) {
    const a = document.createElement('a')
    a.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text))
    a.setAttribute('download', filename)
    a.style.display = 'none'
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
  }
}
